<template>
  <div class="unlimited">
    <section class="retry-area" v-if="responseError">
      <h3 class="retry-area__ttl">通信に失敗しました</h3>
      <a href="javascript:void(0);" @click="getUpgradeStatus" class="btn-retry btn-retry--short">リトライ</a>
    </section>
    <div v-else>
      <div class="card card--no-bottom-border">
        <div class="card__inner">
          <section class="card__body card-body card-body--book-detail">
            <p>プランアップグレードを行う場合、現在のプラン料金とアップグレード後のプラン料金の差額を比例配分した金額が請求されます。<br><br></p>

            <p class="card-body__book-price">現在のプラン料金： ￥{{basePrice}}</p>
            <p class="card-body__book-price">アップグレード後のプラン料金： ￥{{nextPrice}}<br></p>
            <p class="card-body__book-price">プランの残り日数割合： {{remainRatio}}<br><br></p>
            <p class="card-body__abc-price">請求額： <span>￥{{updatedPrice}}</span></p>
          </section>
          <span class="btn-square card__pc-purchase pc-on" @click="onClickUpgrade()">アップグレードする</span>
        </div>
        <div class="card-purchase sp-on">
          <span class="btn-square" @click="onClickUpgrade()">アップグレードする</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery';
  import {credit, subscriptions_prefix, unlimited_subscriptions_prefix } from '../../../constants';

  export default {
    title: 'アップグレード',
    headerTitle: 'アップグレード',
    headerType: 'historyBack',
    resetScrollView: true,
    components: {
    },
    data() {
      return {
        responseError: false,
        activeUnlimitedType: 2,
        fixedMenuShown: false,
        skipPremium: false,
        base_price:0,
        next_price:0,
        updated_price:0,
        remain_ratio:"",
        product_id:""
      }
    },
    beforeRouteUpdate (to, from, next) {
      next();
    },
    created() {
      this.getUpgradeStatus();
    },
    mounted() {
    },
    methods: {
      separate(num) {
        return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      },
      onClickUpgrade() {
        if (this.isCreditAvailabel) {
          let show_amount = this.separate(this.updated_price);
          let show_text = 'アップグレードしてもよろしいですか？\n決済金額：' + show_amount + "円";
          if (!confirm(show_text)) {
            return;
          }
          //クレカ購入済みの場合はその場で決済させる
          this.$store.dispatch("showLightBox", "loading");
          this.$store.dispatch("upgradeByToken", {
            ignore_token: true,
            product_id: this.product_id
          }).then(data => {
            if (data.result) {
              //購入成功
              this.$store.dispatch("hideLightBox");
              this.$store.dispatch("showLightBox", "unlimitedResult");
              //Homeに戻す
              this.$router.push({name: 'rankingHome'});
            } else {
              this.$store.dispatch("hideLightBox");
              alert('購入に失敗しました。登録されているクレジットカードが有効かどうか確認してください。');
            }
          }).catch(() => {
            this.$store.dispatch("hideLightBox");
            alert('購入に失敗しました。登録されているクレジットカードが有効かどうか確認してください。');
          });
        } else {
          this.$router.push({name: 'UpgradeCreditCard', params: { id: this.product_id }});
        }

      },
      getUpgradeStatus() {
        this.$store.dispatch("changeLoadingCondition", true);
        let token = "";
        if (this.$route.query.token) {
          token = this.$route.query.token;
        }
        this.$store.dispatch('getUpgradeStatus', {token:token})
          .then(data => {
            this.responseError = data === 'error';
            if (data.user.sbps_payment_type && data.user.sbps_payment_type === 'credit') {
              this.isCreditAvailabel = true;
            }
            this.$store.dispatch("changeLoadingCondition", false);
            //ログイン成功の場合はログイン処理を行う
            if (data.has_logined) {
              if (data.login_info) {
                this.$store.dispatch("setLogin", data.login_info);
              }
            }
            this.remain_ratio = data.remain_ratio;
            this.base_price = data.base_price;
            this.next_price = data.next_price;
            this.updated_price = data.updated_price;
            this.product_id = data.target_id;
          })
          .catch(() => {
            this.responseError = true;
            this.$store.dispatch("changeLoadingCondition", false);
          });
      }
    },
    computed: {
      remainRatio() {
        return this.remain_ratio;
      },
      updatedPrice() {
        return this.updated_price;
      },
      nextPrice() {
        return this.next_price;
      },
      basePrice() {
        return this.base_price;
      }
    }
  }
</script>

<style scoped lang="scss">

.unlimited {
  width: 800px;
  margin: 0 auto;
  @media screen and (max-width: 768px){
    width: auto;
  }
}

.unlimited-keyvisual {
  position: relative;
  &__bg {
    width: 100%;
    height: 913px;
    @media screen and (max-width: 768px){
      height: auto;
    }
  }
  &__contents {
    position: absolute;
    width: 800px;
    top: 60px;
    left: 50%;
    transform: translate(-50%, 0);
    @media screen and (max-width: 768px){
      top: 22px;
      width: 100%;
    }
  }
}

.unlimited-intro {
  &__title {
    font-size: 54px;
    font-weight: bold;
    margin-bottom: 4px;
    text-align: left;
    margin-left: 30px;
    @media screen and (max-width: 768px){
      font-size: 42px;
      line-height: 1.3;
      margin-left: 15px;
    }
  }
  &__subtitle {
    font-size: 24px;
    text-align: left;
    margin-left: 25px;
    @media screen and (max-width: 768px){
      font-size: 18px;
      margin-left: 10px;
    }
  }
}

.unlimited-types {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.unlimited-type {
  font-size: 14px;
  background-color: #fff;
  color: rgb(158, 158, 158);
  flex: 1;
  padding: 9px 0;
  line-height: 1.5;
  position: relative;
  &:hover {
    cursor: pointer;
  }
  &.is-active {
    color: #FF4247;
  }
  &__discount {
    position: absolute;
    height: 24px;
    line-height: 24px;
    top: -24px;
    left: 0;
    width: 100%;
    background-color: rgb(35, 25, 22);
    color: #fff;
  }
  &__title {
    font-size: 12px;
  }
  &__border {
    position: absolute;
    bottom: 5px;
    height: 3px;
    width: 66%;
    left: 17%;
    background-color: #FF4247;
  }
  &__bottom {
    font-size: 12px;
  }
}

.unlimited-discount-header {
  background-color: white;
  padding: 10px 0 0 0;
}

.unlimited-discount-top {
  font-size: 18px;
  color: #FF4247;
  font-weight: 500;
  margin: 0 10px;
}

.unlimited-discount-sub {
  font-size: 12px;
  text-align: left;
  margin: 0 15px;
  color: #757575;
}

.unlimited-upgrade {
  background-color: #F1F1F1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  @media screen and (max-width: 768px){
    padding: 10px 10px;
  }
  &__title {
    width: calc(100% - 130px);
    text-align: left;
    font-size: 18px;
    margin-left: 10px;
    @media screen and (max-width: 768px){
      font-size: 14px;
    }
  }
  &__body {
    width: 130px;
  }
  .btn-upgrade {
    border-radius: 20px;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #FF4247;
    padding: 8px 3px;
  }
}

.unlimited-guide {
  &--fixed {
    position: fixed;
    width: 800px;
    left: 50%;
    margin-left: -400px;
    bottom: 0;
    @media screen and (max-width: 768px){
      width: 100%;
      left: 0;
      margin: 0;
    }
  }
}

.unlimited-main {
  background-color: #fff;
  padding: 40px 100px;
  @media screen and (max-width: 768px){
    padding: 24px 15px;
  }
}

.unlimited-block {
  margin-bottom: 60px;
  @media screen and (max-width: 768px){
    margin-bottom: 30px;
  }
  &:last-of-type {
    margin-bottom: 0;
  }
  &__title {
    font-size: 26px;
    font-weight: bold;
    margin-bottom: 10px;
    text-align: left;
    @media screen and (max-width: 768px){
      font-size: 21px;
    }
  }
}

.unlimited-tile-body {
  &__link {
    text-align: right;
    padding-top: 10px;
    @media screen and (max-width: 768px){
      padding-top: 6px;
    }
    a {
      color: #FF4247;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}

.unlimited-tile {
  border-radius: 8px;
  overflow: hidden;
  &__img {
    img {
      width: 100%;
    }
  }
  &__body {
    background-color: rgb(238, 238, 238);
    font-size: 21px;
    padding: 30px;
    text-align: left;
    @media screen and (max-width: 768px){
      font-size: 16px;
      padding: 12px;
    }
  }
}

.noneed-premium {
  padding: 30px 0 10px;
  @media screen and (max-width: 768px){
    padding: 20px 0 10px;
  }
  a {
    color: #FF4247;
    font-size: 18px;
    text-decoration: underline;
    @media screen and (max-width: 768px){
      font-size: 16px;
    }
    &:hover {
      text-decoration: none;
    }
  }
}

.payment-policy {
  margin-top: 20px;
  text-align: left;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/campainPage/unlimited/Upgrade.vue